var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 140,
    viewBox: "0 0 144 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1563 132.198H29.3903V126.936H25.8158V132.198H21.0499V117.305H25.8158V122.567H29.3903V117.305H34.1563V132.198ZM46.434 127.929L46.7915 131.94C45.7721 132.351 44.5144 132.556 43.0184 132.556C41.6019 132.556 40.4303 132.404 39.5035 132.099C38.5768 131.781 37.8421 131.305 37.2993 130.669C36.7565 130.034 36.3726 129.226 36.1475 128.247C35.9357 127.267 35.8298 126.109 35.8298 124.772C35.8298 123.474 35.9291 122.342 36.1277 121.376C36.3395 120.396 36.7102 119.582 37.2397 118.933C37.7693 118.271 38.4842 117.775 39.3844 117.444C40.2979 117.113 41.4496 116.947 42.8397 116.947C43.1442 116.947 43.4818 116.967 43.8525 117.007C44.2364 117.033 44.6071 117.073 44.9645 117.126C45.3352 117.179 45.6794 117.245 45.9972 117.325C46.3281 117.391 46.5929 117.47 46.7915 117.563L46.0766 121.217C45.0175 120.992 44.0709 120.879 43.2369 120.879C42.3764 120.879 41.7806 120.959 41.4496 121.118C41.1187 121.277 40.9532 121.594 40.9532 122.071V128.306C41.2577 128.372 41.5622 128.425 41.8667 128.465C42.1844 128.492 42.5087 128.505 42.8397 128.505C44.1636 128.505 45.3617 128.313 46.434 127.929ZM53.2178 132.198H48.4518V117.305H53.2178V132.198ZM75.1404 127.81V127.174H73.929V123.52H79.6681V131.484C77.7882 132.198 75.8354 132.556 73.8099 132.556C72.4198 132.556 71.2681 132.39 70.3546 132.059C69.4543 131.729 68.7395 131.239 68.2099 130.59C67.6803 129.928 67.3097 129.114 67.0978 128.147C66.8993 127.168 66.8 126.029 66.8 124.732C66.8 123.355 66.9257 122.177 67.1773 121.197C67.4288 120.204 67.8458 119.397 68.4283 118.774C69.0108 118.139 69.7853 117.676 70.7517 117.384C71.7182 117.093 72.9163 116.947 74.3461 116.947C74.6638 116.947 75.0345 116.967 75.4581 117.007C75.895 117.033 76.3319 117.08 76.7688 117.146C77.2056 117.199 77.616 117.265 78 117.345C78.3971 117.411 78.7149 117.484 78.9532 117.563L78.2383 121.217C77.5896 121.111 76.974 121.032 76.3915 120.979C75.809 120.912 75.2662 120.879 74.7631 120.879C73.7172 120.879 72.9825 120.959 72.5588 121.118C72.1352 121.277 71.9234 121.594 71.9234 122.071V128.823H73.4922C74.0747 128.823 74.4917 128.763 74.7432 128.644C75.008 128.511 75.1404 128.233 75.1404 127.81ZM85.8981 129.835L85.3619 132.198H80.3378L84.1903 117.305H91.5577L95.4101 132.198H90.386L89.83 129.835H85.8981ZM88.0031 121.872H87.7449L86.7718 126.042H88.9562L88.0031 121.872ZM100.999 124.97L100.721 132.198H95.7367L96.6502 117.305H102.866L104.713 124.891H104.891L106.738 117.305H112.974L113.867 132.198H108.883L108.605 124.97H108.446L106.619 132.198H102.985L101.138 124.97H100.999ZM125.18 123.123V126.579H120.414V128.386H126.252V132.198H115.648V117.305H126.133L125.537 121.118H120.414V123.123H125.18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3538 128.028L57.673 130.709L55.6474 128.684L58.3283 126.003L55.6474 123.322L57.673 121.296L60.3538 123.977L63.0347 121.296L65.0602 123.322L62.3794 126.003L65.0602 128.684L63.0347 130.709L60.3538 128.028Z",
    fill: "#6AA4DA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.5039,
    y: 17.8723,
    width: 5.95745,
    height: 29.7872,
    fill: "#2D2D2D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9004,
    y: 39.7163,
    width: 117.163,
    height: 65.5319,
    rx: 19.8582,
    fill: "#6AA4DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.8301,
    y: 47.6597,
    width: 97.305,
    height: 48.6525,
    rx: 14.8936,
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 75.9575C0 69.1029 5.55675 63.5461 12.4114 63.5461H12.637C13.3349 63.5461 13.9007 64.1119 13.9007 64.8098V87.1051C13.9007 87.8031 13.3349 88.3688 12.637 88.3688H12.4114C5.55675 88.3688 0 82.8121 0 75.9575Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.408 74.9646C144.408 81.8192 138.851 87.376 131.997 87.376L131.771 87.376C131.073 87.376 130.507 86.8102 130.507 86.1123L130.507 63.817C130.507 63.1191 131.073 62.5533 131.771 62.5533L131.997 62.5533C138.851 62.5533 144.408 68.11 144.408 74.9646Z",
    fill: "#2D2D2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.4818,
    cy: 9.92908,
    r: 9.92908,
    fill: "#FF9292"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.6386,
    cy: 67.5177,
    r: 7.94326,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.3192,
    cy: 67.5177,
    r: 7.94326,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.be2cdee2012c086fb159ed6132507ace.svg";
export { ForwardRef as ReactComponent };